<template>
  <canvas :height="height"></canvas>
</template>

<script>
import { HorizontalBar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ['chartData', 'options', 'height'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
</script> 